import { MapPin, Building2, ArrowDownLeft, ArrowUpRight } from "lucide-react";
import { ConnectReveal } from "./ConnectReveal";
import { CATEGORY_LABELS } from "./categories";

export const PostCard = ({ post: p }) => {
  const isNeed = p.post_type === "need";

  const accentText = isNeed ? "text-[#00F0FF]" : "text-[#B57BEE]";
  const accentBorder = isNeed ? "border-l-[#00F0FF]" : "border-l-[#8A2BE2]";
  const badgeCls = isNeed
    ? "text-[#00F0FF] border-[#00F0FF]/40 bg-[#00F0FF]/5"
    : "text-[#B57BEE] border-[#8A2BE2]/50 bg-[#8A2BE2]/10";
  const tintCls = isNeed ? "bg-[#00F0FF]/[0.025]" : "bg-[#8A2BE2]/[0.05]";

  return (
    <article
      className={`card-frame border-l-2 ${accentBorder} ${tintCls} p-5 sm:p-7 flex flex-col`}
      data-testid={`post-card-${p.id}`}
    >
      <div className="flex items-center justify-between gap-3">
        <span
          data-testid={`post-card-type-${p.id}`}
          className={`flex items-center gap-1.5 font-mono-accent text-[10px] font-bold uppercase tracking-[0.25em] px-2.5 py-1 border ${badgeCls}`}
        >
          {isNeed ? <ArrowDownLeft size={11} /> : <ArrowUpRight size={11} />}
          {isNeed ? "Need" : "Offer"}
        </span>
        <span className="font-mono-accent text-[10px] tracking-[0.18em] text-slate-600 uppercase text-right truncate max-w-[46%]">
          {CATEGORY_LABELS[p.category] || p.category}
        </span>
      </div>

      <p className={`mt-4 font-mono-accent text-[10px] uppercase tracking-[0.25em] ${accentText}`}>
        {isNeed ? "Is looking for" : "Is offering"}
      </p>
      <p className="mt-2 text-slate-200 text-sm sm:text-base leading-relaxed flex-1">{p.description}</p>

      <div className="mt-6 pt-5 border-t border-white/10 space-y-2.5">
        <div className="flex items-center gap-2.5 text-sm text-slate-300">
          <Building2 size={14} className="text-slate-600 shrink-0" />
          <span className="truncate">{p.name}</span>
        </div>
        <div className="flex items-center gap-2.5 text-sm text-slate-500">
          <MapPin size={14} className="text-slate-600 shrink-0" />
          <span className="truncate">{p.location}</span>
        </div>
      </div>

      <div className="mt-5">
        <ConnectReveal postId={p.id} isNeed={isNeed} testPrefix="post-card" />
      </div>
    </article>
  );
};
